/** @format */

import React from 'react';
import { Col, Row } from 'antd';
import { sanitizePhoneNumberForInput } from '../../../utils/phoneNumberSanitizer';

interface MemberInformationProps {
  formData: {
    firstName: string;
    lastName: string;
    phoneNumber: string | number;
    email: string;
    typeOfWork?: string;
    occupation?: string;
    SSN?: string;
    ssn?: string;
    dateOfBirth?: string;
    dob?: string;
    householdIncome: number | null;
  };
  showAcaFields: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const MemberInformation: React.FC<MemberInformationProps> = ({
  formData,
  showAcaFields,
  onChange,
}) => {
  // Custom handler for phone number to sanitize input
  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitizedValue = sanitizePhoneNumberForInput(e.target.value);
    
    // Create a new event with sanitized value
    const sanitizedEvent = {
      ...e,
      target: {
        ...e.target,
        value: sanitizedValue,
        name: 'phoneNumber'
      }
    } as React.ChangeEvent<HTMLInputElement>;
    
    onChange(sanitizedEvent);
  };
  return (
    <Row gutter={[24, 24]}>
      <Col sm={24} md={24} lg={24} xl={24}>
        <div className='form-heading'>
          <span>Member Information</span>
        </div>
      </Col>

      <Col sm={24} md={12} lg={12} xl={12}>
        <div className='form-input-wrapper'>
          <label style={{ marginBottom: '10px' }}>Member First Name *</label>
          <input
            type='text'
            name='firstName'
            value={formData.firstName || ''}
            onChange={onChange}
            required
          />
        </div>
      </Col>

      <Col sm={24} md={12} lg={12} xl={12}>
        <div className='form-input-wrapper'>
          <label style={{ marginBottom: '10px' }}>Member Last Name *</label>
          <input
            type='text'
            name='lastName'
            value={formData.lastName || ''}
            onChange={onChange}
            required
          />
        </div>
      </Col>

      <Col sm={24} md={12} lg={12} xl={12}>
        <div className='form-input-wrapper'>
          <label>Member Phone Number *</label>
          <input
            type='text'
            name='phoneNumber'
            value={formData.phoneNumber || ''}
            onChange={handlePhoneNumberChange}
            placeholder="Enter 10-digit phone number"
            maxLength={10}
            required
          />
        </div>
      </Col>

      {showAcaFields && (
        <>
          <Col sm={24} md={12} lg={12} xl={12}>
            <div className='form-input-wrapper'>
              <label style={{ marginBottom: '10px' }}>Email</label>
              <input
                type='text'
                name='email'
                value={formData.email || ''}
                onChange={onChange}
                required
              />
            </div>
          </Col>

          <Col sm={24} md={12} lg={12} xl={12}>
            <div className='form-input-wrapper'>
              <label style={{ marginBottom: '10px' }}>Occupation</label>
              <input
                type='text'
                name='occupation'
                value={formData.occupation ?? ''}
                onChange={onChange}
                required
              />
            </div>
          </Col>

          <Col sm={24} md={12} lg={12} xl={12}>
            <div className='form-input-wrapper'>
              <label style={{ marginBottom: '10px' }}>Member SSN *</label>
              <input
                type='text'
                name='ssn'
                value={formData.ssn ?? ''}
                onChange={onChange}
                required
              />
            </div>
          </Col>
        </>
      )}

      <Col sm={24} md={12} lg={12} xl={12}>
        <div className='form-input-wrapper'>
          <label>Member Date of Birth *</label>
          <input
            type='date'
            name='dob'
            value={formData.dob || ''}
            onChange={onChange}
            required
          />
        </div>
      </Col>

      {showAcaFields && (
        <Col sm={24} md={12} lg={12} xl={12}>
          <div className='form-input-wrapper'>
            <label>Member Household Income *</label>
            <input
              type='number'
              name='householdIncome'
              value={formData.householdIncome ?? ''}
              onChange={onChange}
              required
            />
          </div>
        </Col>
      )}
    </Row>
  );
};
